import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ark-splash',
  templateUrl: './splash.component.html',
  styleUrls: ['./splash.component.scss']
})
export class SplashComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
